<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Lista Partnerów</v-flex>

        <v-spacer />

        <v-flex>
          <search />
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="ACCOUNT.REGISTER.PARTNER">
            <v-btn large color="error" @click="showAddModal">DODAJ PARTNERA</v-btn>
          </check-permission>

          <check-permission permissions="PARTNER.CSV">
            <post-form text="Pobierz CSV" :url="csvUrl" :fields="csvFilters" />
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        entityType="partner"
        :headers="headers"
        :actions="actions"
        :items="list"
        :total-count="count"
        @edit="showEdit($event.id)"
        @delete="showDeleteDialog($event.id)"
        @details="goToDetails"
      />

      <material-dialog
        title="Potwierdź usunięcie"
        text="Czy na pewno chcesz usunąć Partnera?"
        :show="!!idToDelete"
        :id="idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      />

      <edit-modal :show="editModal" :partnerToEdit="partnerToEdit" @close="hideEditModal" @update="update" />
    </material-card>

    <modal :show="showModal" @close="hideModal" @save="add" />
  </v-container>
</template>

<script>
import { address, State, StateTranslation } from '@witkac/kartamiejska-shared';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Search from '@/components/material/table/Search';
import PostForm from '@/components/postForm/PostForm';
import { listMixin } from '@/mixins/list';
import { DELETE_ACTION, EDIT_ACTION } from '@/utils/actions';
import { config } from '@/utils/config';
import Modal from './modals/Add.modal';
import EditModal from './modals/Edit.modal';

// @vuese
// Wyświetlanie listy Partnerów
// @group Partners
export default {
  components: {
    EditModal,
    MaterialCard,
    MaterialTable,
    MaterialDialog,
    Modal,
    PostForm,
    Search
  },
  mixins: [
    listMixin('partners', {
      added: 'Dodano Partnera.',
      addError: 'Nie udało się dodać Partnera.',
      updated: 'Zaktualizowano Partnera.',
      updateError: 'Nie udało się zaktualizować Partnera.',
      deleted: 'Usunięto Partnera.',
      deleteError: 'Nie udało się usunąć Partnera.',
      listError: 'Nie udało się pobrać listy Partnerów.'
    })
  ],
  data() {
    return {
      csvUrl: config.csvURL + '/partner',
      headers: [
        { text: 'Nazwa Partnera', value: 'name', orderBy: 'name', link: true },
        {
          text: 'Status',
          orderBy: 'state',
          value: 'state',
          render: item => StateTranslation[State[item.state]]
        },
        {
          text: 'Adres',
          value: 'street',
          orderBy: ['street', 'homeNumber', 'localNumber', 'postalCode', 'city'],
          render: item => address(item)
        },
        { text: 'Liczba usług', value: 'benefitsCount', sortable: false }
      ],
      actions: [DELETE_ACTION, EDIT_ACTION],
      editModal: false,
      partnerToEdit: {}
    };
  },
  methods: {
    // @vuese
    // Pobiera dane Partnera do edycji
    // @arg `id` - identyfikator Partnera
    async showEdit(id) {
      this.partnerToEdit = await this.$store.dispatch('partners/get', id);
      this.showEditModal();
    },
    // @vuese
    // Otwiera modal do edycji Partnera
    showEditModal() {
      this.editModal = true;
    },
    // @vuese
    // Ukrywa modal edycji
    hideEditModal() {
      this.editModal = false;
      this.partnerToEdit = {};
    },
    goToDetails(partner) {
      this.$router.push({ name: 'partner', params: { id: partner.id } });
    }
  },
  watch: {
    '$store.state.modalClose.confirm'(val) {
      if (val) {
        this.editModal ? this.hideEditModal() : this.hideModal();
        this.$store.dispatch('resetConfirmState');
      }
    }
  }
};
</script>
